
export const paragraphMapper = (paragraph: any) => {
  switch (paragraph) {
    case 'hero':
      return import('../components/paragraphs/hero/hero.module').then((m) => m.HeroModule);
    case 'accordion':
      return import('../components/paragraphs/accordion/accordion.module').then((m) => m.AccordionModule);
    case 'news_loader':
      return import('../components/paragraphs/news_loader/news_loader.module').then((m) => m.NewsLoaderModule);
    case 'faq_loader':
      return import('../components/paragraphs/faq_loader/faq_loader.module').then((m) => m.FaqLoaderModule);
    case 'attachments':
      return import('../components/paragraphs/attachments/attachments.module').then((m) => m.AttachmentsModule);
    case 'image_gallery':
      return import('../components/paragraphs/image_gallery/image_gallery.module').then((m) => m.ImageGalleryModule);
    case 'text':
      return import('../components/paragraphs/text/text.module').then((m) => m.TextModule);
    case 'card_loader':
      return import('../components/paragraphs/card_loader/card_loader.module').then((m) => m.CardLoaderModule);
    case 'event_loader':
      return import('../components/paragraphs/event_loader/event_loader.module').then((m) => m.EventLoaderModule);
    case 'contact_point_loader':
      return import('../components/paragraphs/contact_point_loader/contact_point_loader.module').then((m) => m.ContactPointLoaderModule);
    case 'place_loader':
      return import('../components/paragraphs/place_loader/place_loader.module').then((m) => m.PlaceLoaderModule);
    case 'org_unit_loader':
      return import('../components/paragraphs/org_unit_loader/org_unit_loader.module').then((m) => m.OrgUnitLoaderModule);
    case 'person_loader':
      return import('../components/paragraphs/person_loader/person_loader.module').then((m) => m.PersonLoaderModule);
    case 'document_loader':
      return import('../components/paragraphs/document_loader/document_loader.module').then((m) => m.DocumentLoaderModule);
    case 'service_layout_loader':
      return import('../components/paragraphs/service_layout_loader/service_layout_loader.module').then((m) => m.ServiceLayoutLoaderModule);
    case 'service_list_loader':
      return import('../components/paragraphs/service_list_loader/service_list_loader.module').then((m) => m.ServiceListLoaderModule);
    case 'tag_loader':
      return import('../components/paragraphs/tag_loader/tag_loader.module').then((m) => m.TagLoaderModule);
    case 'thematic_sites':
      return import('../components/paragraphs/thematic_sites/thematic_sites.module').then((m) => m.ThematicSitesModule);
    case 'useful_links':
      return import('../components/paragraphs/useful_links/useful_links.module').then((m) => m.UsefulLinksModule);
    case 'video_loader':
      return import('../components/paragraphs/video_loader/video_loader.module').then((m) => m.VideoLoaderModule);
    case 'page_loader':
      return import('../components/paragraphs/page_loader/page_loader.module').then((m) => m.PageLoaderModule);
    case 'information_loader':
      return import('../components/paragraphs/information_loader/information_loader.module').then((m) => m.InformationLoaderModule);
        
      // Add more cases as needed
    default:
      return null;
  }
}
